import { Zeiterfassung } from "../../../formular-model/formular-groups/interfaces/FormularGroupZeiterfassung";

export interface ItemRequest {
    state: "new" | "edit",
    data: Zeiterfassung | null,
}

export interface ItemResult { state: boolean, data: Zeiterfassung | null }

export function getDate(isodate: string) {
    if (isodate.length >= 10) {
        return isodate.slice(0, 10);
    }

    return isodate;
}

export function getTime(isodate: string) {
    if (isodate.length > 8 && isodate.includes("T")) {
        return isodate.split("T")[1].slice(0, 5);
    }

    if (isodate.length === 8) {
        return isodate.slice(0, 5);
    }

    return isodate;
}
